import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const o=i("maldives",l`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#007E3A" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19 7.83333H5V17.1667H19V7.83333ZM0 4.5V20.5H24V4.5H0Z"
                fill="#D21034" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.375 16.0316C14.1321 16.0731 13.8813 16.0947 13.625 16.0947C11.4159 16.0947 9.625 14.4851 9.625 12.4995C9.625 10.5139 11.4159 8.9043 13.625 8.9043C13.8813 8.9043 14.1321 8.92597 14.375 8.96739C12.5244 9.28292 11.125 10.7443 11.125 12.4995C11.125 14.2547 12.5244 15.7161 14.375 16.0316Z"
                fill="white" />
        </svg>
    `),C=i("maldives_rounded",l`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92926)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5Z"
                    fill="#007E3A" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 19.5C15.866 19.5 19 16.366 19 12.5C19 8.63401 15.866 5.5 12 5.5C8.13401 5.5 5 8.63401 5 12.5C5 16.366 8.13401 19.5 12 19.5ZM12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z"
                    fill="#D21034" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.8789 16.4298C13.636 16.4759 13.3853 16.5 13.1289 16.5C10.9198 16.5 9.12891 14.7091 9.12891 12.5C9.12891 10.2909 10.9198 8.5 13.1289 8.5C13.3853 8.5 13.636 8.52411 13.8789 8.5702C12.0283 8.92125 10.6289 10.5472 10.6289 12.5C10.6289 14.4528 12.0283 16.0787 13.8789 16.4298Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92926">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Maldives,C as MaldivesRounded};
